module.exports = __webpack_public_path__ + "static/media/success.1f3f35e0.svg";